export enum CourierGatewayEnum {
  CourierGatewayCollection = "CourierGatewayCollection",
  CourierGateway = "CourierGateway",
}
export enum CourierGatewayStatus {
  active = "active",
  inactive = "inactive",
}
